export default __webpack_public_path__ + "static/media/AutomationTrash.40e90bf5.svg";